import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { HeaderData } from '@/shared/ui/organisms/Header/header';
import { headerMock } from '@/shared/store/mocks/header.mock';
import { createAppAsyncThunk } from '@/shared/store/utils/createAppAsyncThunk';

export const fetchHeader = createAppAsyncThunk<HeaderData>('header/fetchHeader', async (_arg, { state }) => {
    if (state.general.useMockDelay) {
        await new Promise(res => setTimeout(res, 800));
    }
    return headerMock;
});

const initialState: HeaderData = {
    logo: headerMock.logo,
    nav: headerMock.nav,
    error: null as string | null,
};

const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchHeader.fulfilled, (state, action: PayloadAction<HeaderData>) => {
            state.logo = action.payload.logo;
            state.nav = action.payload.nav;
        });
    },
});

export default headerSlice.reducer;
